import React from "react";
import { Card } from "react-bootstrap";

import { CLIENT_ID } from "../../../constants/env";
import logo from "../../../assets/images/aol-logo.png";
import { Input, CardView, ButtonView } from "../../controls";
import styles from "./LoginStyles.scss";
import { history } from "../../../store/configure/configureStore";
import { Loader } from "../../common";
import { globals } from "../../../store/globals";

const LoginView = ({ onLogin, onChange, fields, isLoader, errors }) => {
  const renderHeader = () => {
    return (
      <>
        <div className="title-container">
          <div className="title">
            <img className="title-logo" src={logo} alt="Logo" />
          </div>
          <div className="sub-title-wrapper">
            <span className="welcome-text">Hello, Welcome</span>
            <span className="instruction-text">Login to your account</span>
          </div>
        </div>
      </>
    );
  };
  return (
    <div className="login_container">
      <CardView
        // image={logo}
        customCardControl={"card-control"}
        customBodyStyles={"card-body-styles"}
        customCardText={"card-text"}
        customTitleStyles={"card-head-title"}
        title={renderHeader()}
      >
        <div className="inner_login_container">
          <div className="wrapper">
            <Input
              value={fields["email"]}
              name={"email"}
              label={"Email Address"}
              placeholder="Enter Email"
              type="text"
              className={"shadow-sm"}
              onChange={onChange}
              size="lg"
              error={errors["email"]}
              isrequired
            />
          </div>
          <div className="wrapper">
            <Input
              value={fields["password"]}
              name={"password"}
              label={"Password"}
              placeholder="Enter Password"
              type="password"
              onChange={onChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onLogin();
                }
              }}
              // disabled={loading}
              size="lg"
              className={"shadow-sm"}
              error={errors["password"]}
              isrequired
            />
          </div>
          {/* <div
            className={`mt-2 d-flex linkStyle`}
            onClick={() => history.push("/otpverification")}
          >
            Login By OTP
          </div> */}
          <div className="action-wrapper">
            {!isLoader && (
              <ButtonView
                title="Login"
                styles="secondary"
                size="large-full-width"
                onClick={onLogin}
              />
            )}
          </div>
          <div className="mt-3">
            <p
              onClick={() => history.push("/forgot_password")}
              className="password-action"
            >
              {/* Forgot Password? */}
            </p>
          </div>
        </div>
      </CardView>
    </div>
  );
};

export default LoginView;
